<template>
  <div>
    <vxe-toolbar size="mini" v-if="canEdit">
      <template v-slot:buttons>
        <vxe-button
          @click="addRow()"
          type="primary"
          size="medium"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          >新增</vxe-button
        >
        <vxe-button
          @click="deleteRow()"
          type="primary"
          size="medium"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          >删除</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-grid
      border
      resizable
      show-overflow
      :max-height="$store.state.app.tableHeight"
      :data="tableData"
      :edit-config="{ trigger: 'click', mode: 'row', activeMethod: this.activeRowMethod }"
      size="mini"
      ref="rowDetailRef"
      :edit-rules="validRules"
      :columns="columnList"
      :valid-config="{ autoPos: true, message: 'inline' }"
      @edit-closed="editClosedEvent"
      align="center"
      auto-resize
      :show-footer="true"
      :footer-method="footerMethodTotal"
      @select-change="handleSelectionChange"
      @select-all="handleSelectionChange"
    >
    </vxe-grid>
  </div>
</template>
<script>
  import rowDetailMixin from './index.js';
  import XEUtils from 'xe-utils';

  export default {
    props: {
      canEdit: {
        type: Boolean,
        default: false,
      },
      invoiceInfo: {
        type: Object,
        default: () => {},
      },
      currentRowInfo: {
        type: Object,
        default: () => {},
      },
    },
    mixins: [rowDetailMixin],
    components: {},
    data() {
      return {
        footerTotalCols: {
          amount: [
            'invoiceAmount',
            'ladingAmount',
            'settlementApplyInvoiceAmount',
            'excludedTaxAmount',
            'taxAmount',
            'invoiceAccountedAmount',
            'excludedTaxAccountedAmount',
            'taxAccountedAmount',
            'ladingDifferenceAmount',
          ],
          quantity: ['ladingQuantity'],
          invoiceQuantity: ['invoiceQuantity'],
        },
        tableData: [],
        invoiceType: '',
        companyCode: '',
        taxRateList: [], //税率列表
        departmentList: [],
        isVisibleSettlement: false,
        expenseItemList: [],
      };
    },

    mounted() {
      //税率
      this.$baseRequest.getTaxRate().then((res) => {
        this.taxRateList = res.filter((it) => it.taxType == 'OT');
      });
    },
    watch: {
      canEdit: {
        handler(val) {
          this.showButton = val;
        },
        immediate: true,
      },
      currentRowInfo: {
        handler(val) {
          console.log('传递过来的当前行信息', val);
          this.tableData = val?.detailExtendList || [];
        },
        deep: true,
      },
      'invoiceInfo.businessType': {
        handler(newValue, oldValue) {
          console.log(newValue, '切换变化', oldValue);
          // expenseItemList
          if (newValue) {
            const dictMap = {
              '01': this.dictListMap.IncomeExpenseItemsTrade || [], // 贸易
              '02': this.dictListMap.IncomeExpenseItemsTransportation || [], // 多式联运
              '03': this.dictListMap.IncomeExpenseItemsWarehousing || [], // 园区仓储
              '04': this.dictListMap.IncomeExpenseItemsParkProperties || [], // 园区物业
              '05': this.dictListMap.IncomeExpenseItemsSupervisionForm || [], // 监管单
              '06': this.dictListMap.IncomeExpenseItemsTrade || [], // 城矿
            };
            this.expenseItemList = dictMap[newValue];
            if (newValue != oldValue) {
              console.log('进来了');
            }
          }
        },
        immediate: true,
        deep: true,
      },
    },
    methods: {
      footerMethodTotal({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            for (let key in this.footerTotalCols) {
              if (this.footerTotalCols[key].includes(column.property)) {
                let total = XEUtils.calSum(data, column.property);
                let point = this.$globalVar.aPoint;
                if (['excludedTaxAmount', 'invoiceAmount'].includes(key)) {
                  point = 2;
                } else if (key == 'invoiceQuantity') {
                  point = 8;
                }
                total = this.replaceZeroStr(XEUtils.toNumber(total).toFixed(point));
                return total;
              }
            }
          }),
        ];
      },
      getTableData() {
        return this.$refs.rowDetailRef.getTableData().fullData;
      },
      // 新增行
      async addRow() {
        if (this.currentRowInfo == null || JSON.stringify(this.currentRowInfo) == '{}') {
          return this.$message.warning('请选择行信息！');
        }

        let checkLinesRefStatus = await this.validAllEvent(true);
        if (checkLinesRefStatus) {
          return;
        }
        const rowData = {
          receivableSettlementNo: this.currentRowInfo.receivableSettlementNo,
          receivableSettlementLineId: this.currentRowInfo.receivableSettlementLineId,
          invoiceDesc: '',
          productSpecificationModel: '',
          invoiceQuantity: '',
          invoiceUnitPrice: '',
          invoiceUnit: '',
          excludedTaxAmount: '',
          invoiceAmount: '',
          taxRate: '',
          mark: '',
        };
        this.insertEvent(rowData, 0);
      },
      // 插入数据
      async insertEvent(rowData = {}, index = 0) {
        const $table = this.$refs.rowDetailRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (!errMap) {
          const { row: newRow } = await $table.insertAt(rowData, index);
          await $table.setActiveRow(newRow); // 设置当前行为活跃
        }
        console.log('明细列表插入行', this.currentRowInfo.receivableSettlementLineId);
        this.$emit('rowDetailInsert', this.currentRowInfo.receivableSettlementLineId, rowData);
      },
      // 校验表格
      async validAllEvent() {
        const $table = this.$refs.rowDetailRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (errMap) {
          return true;
        } else {
          return false;
        }
      },
      deleteRow() {
        let selectionList = this.$refs.rowDetailRef.getCheckboxRecords();
        if (!selectionList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        const xIDList = selectionList.map((item) => item._XID);
        this.tableData = this.getTableData().filter((item) => !xIDList.includes(item._XID));
        this.$refs.rowDetailRef.removeSelecteds();
        this.$emit('deleteRowDetail', this.currentRowInfo.receivableSettlementLineId, xIDList);
      },
      updateCol(row, val, type) {
        console.log(row, val, type, '更新行信息');
        row[type] = val;
        if (type == 'taxRate') {
          if (row['invoiceAmount']) {
            if (row['invoiceAmount']) {
              let step1 = this.$cal.calCommon(1, row['taxRate'], '+');
              // 不含税 = 含税/（1+税率）
              row['excludedTaxAmount'] = this.$cal.calCommon(
                row['invoiceAmount'],
                step1,
                '/',
                'amount'
              );
            }
          } else {
            row['excludedTaxAmount'] = '0';
          }
        } else if (type == 'invoiceQuantity') {
          if (row['invoiceQuantity']) {
            if (row['invoiceUnitPrice']) {
              row['invoiceAmount'] = this.$cal.calCommon(
                row['invoiceUnitPrice'],
                row['invoiceQuantity'],
                '*',
                'amount'
              );
              if (row['taxRate']) {
                let step1 = this.$cal.calCommon(1, row['taxRate'], '+');
                // 不含税 = 含税/（1+税率）
                row['excludedTaxAmount'] = this.$cal.calCommon(
                  row['invoiceAmount'],
                  step1,
                  '/',
                  'amount'
                );
              }
            } else {
              row['invoiceAmount'] = '0';
              row['excludedTaxAmount'] = '0';
            }
          }
          // 修改总额跟数量 计算单价
        } else if (type == 'invoiceUnitPrice') {
          if (row['invoiceUnitPrice']) {
            if (row['invoiceQuantity']) {
              row['invoiceAmount'] = this.$cal.calCommon(
                row['invoiceUnitPrice'],
                row['invoiceQuantity'],
                '*',
                'amount'
              );
              if (row['taxRate']) {
                let step1 = this.$cal.calCommon(1, row['taxRate'], '+');
                // 不含税 = 含税/（1+税率）
                row['excludedTaxAmount'] = this.$cal.calCommon(
                  row['invoiceAmount'],
                  step1,
                  '/',
                  'amount'
                );
              }
            } else {
              row['invoiceAmount'] = '0';
              row['excludedTaxAmount'] = '0';
            }
          }
        } else if (type == 'invoiceAmount') {
          if (row['invoiceAmount']) {
            if (row['invoiceQuantity']) {
              row['invoiceUnitPrice'] = this.$cal.calCommon(
                row['invoiceAmount'],
                row['invoiceQuantity'],
                '/',
                8
              );
              if (row['taxRate']) {
                let step1 = this.$cal.calCommon(1, row['taxRate'], '+');
                // 不含税 = 含税/（1+税率）
                row['excludedTaxAmount'] = this.$cal.calCommon(
                  row['invoiceAmount'],
                  step1,
                  '/',
                  'amount'
                );
              }
            } else {
              row['invoiceUnitPrice'] = '0';
              row['excludedTaxAmount'] = '0';
            }
          }
        }

        this.$emit('updateRowDetail', this.currentRowInfo.receivableSettlementLineId);
      },
      editClosedEvent(row) {
        console.log(row);
      },
      // 选择行的时候
      handleSelectionChange(row) {
        console.log(row.selection);
        //   this.$emit('selectionChanged', row.selection);
      },
      activeRowMethod({ columnIndex, row }) {
        console.log(columnIndex, row);
        //禁用编辑
        if (this.showButton) {
          if ([9].includes(columnIndex)) {
            return false;
          } else {
            return true;
          }
        }
        return this.showButton;
      },
    },
  };
</script>
<style lang="scss" scoped>
  .price-col {
    line-height: 18px;
  }
</style>
